import qs from 'qs';
import { takeLatest, put, select } from 'redux-saga/effects';
import {
  OPEN_LEAD_MAILER_WITH_CLIENT_DATA,
  OPEN_LEAD_MAILER_WITH_CLIENT_DATA_SUCCESS,
} from '../actions/leadMailer';
import sendMessageManagerBus from '../../utils/sendMessageManagerBus';
import { safeApply, safeCall } from './errors';

const TOUR_SELECTIONS_ADMIN_URL = `${process.env.API_HOST_URL}/admin/tour_selections/new`;

function* openTourSelectionsAdmin() {
  const { activeTicket } = yield select((state) => state.tickets);

  if (!activeTicket?.id || !activeTicket.client?.id) return;

  const params = {
    ticket_id: activeTicket.id,
    client_id: activeTicket.client.id,
  };
  const queryParams = qs.stringify(params);

  yield safeCall(sendMessageManagerBus, {
    direction: `${TOUR_SELECTIONS_ADMIN_URL}?${queryParams}`,
    urlPattern: `${TOUR_SELECTIONS_ADMIN_URL}*`,
    payload: params,
  });

  yield put({ type: OPEN_LEAD_MAILER_WITH_CLIENT_DATA_SUCCESS });
}

export default function* () {
  yield takeLatest(
    OPEN_LEAD_MAILER_WITH_CLIENT_DATA,
    safeApply(openTourSelectionsAdmin)
  );
}
